import {MenuItem, Select} from "@mui/material"
import {Box} from "@mui/system"
import {FC, Fragment, useEffect, useState} from "react"
import {ClimbingEvent} from "../../models/ClimbingEvent"
import {listAllEvents} from "../../services/events/EventService"
import {EventCompetingComponent} from "./components/EventCompetingComponent"
import {useTranslation} from "react-i18next";
import {DateTime} from "luxon";


export const EventCompletingPage: FC = () => {
  const {t} = useTranslation();
  const [events, setEvents] = useState<ClimbingEvent[]>([])
  const [selectedEventIndex, setSelectedEventIndex] = useState<number>()
  useEffect(() => {
    listAllEvents().then((snapshots) => {
      const climbingEvents = snapshots.sort((a, b) => b.endDate - a.endDate)
        .filter((event)=>!!event.endDate);
      const onlyRecent = climbingEvents
        .filter((event) => DateTime.fromMillis(event.endDate) >= DateTime.local().minus({days: 7}))
      console.log(onlyRecent)
      if(onlyRecent.length > 0) {
        setEvents(onlyRecent)
      }else{
        setEvents(climbingEvents.slice(-1))
      }
    })
  }, [])

  useEffect(() => {
    if (!selectedEventIndex && events.length > 0) {
      setSelectedEventIndex(0)
    }
  }, [events, selectedEventIndex])

  return (
    <Fragment>
      <Box
        sx={{display: "flex", alignItems: "center", flexDirection: "column"}}
        mb={5}>
        {events.length > 1 && (
          <Box sx={{alignItems: "center", m: 1, display: "flex", flexDirection: "column"}}>
            <Select
              sx={{width: 300}}
              value={selectedEventIndex !== undefined ? events[selectedEventIndex].name : ""}
              label={t('event.event')}>
              {events.map((event, index) => <MenuItem onClick={() => setSelectedEventIndex(index)} key={event.name}
                                                      value={event.name}>{event.name}</MenuItem>)}
            </Select>
          </Box>
        )
        }
        {selectedEventIndex !== undefined &&
            <EventCompetingComponent event={events[selectedEventIndex]}/>
        }

      </Box>

    </Fragment>)
}
